import { Phone, ShieldCheck, Factory, BadgeCheck, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import ZLDCalculatorTrigger from "@/components/ZLDCalculator";

const trustBadges = [
  { icon: Factory, label: "Turnkey Solutions" },
  { icon: ShieldCheck, label: "CPCB / SPCB Compliant" },
  { icon: MapPin, label: "Made in India" },
  { icon: BadgeCheck, label: "ISO Quality" },
];

const scrollToContact = () => {
  document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
};

const HeroSection = () => {
  return (
    <section
      id="home"
      className="relative min-h-[100svh] flex flex-col items-center justify-center overflow-hidden bg-background"
    >
      <div className="container-custom relative z-10 text-center px-5 lg:px-6 pt-32 md:pt-36 lg:pt-40 3xl:pt-44 pb-12 lg:pb-16">
        <p className="text-sm md:text-base font-semibold text-secondary mb-5 tracking-wide uppercase">
          Rameon Energy · ZLD Plant Technologies
        </p>

        <h1 className="heading-display max-w-4xl lg:max-w-5xl 3xl:max-w-6xl mx-auto mb-5 lg:mb-6">
          Leading <span className="text-secondary">MEE, ATFD &amp; ZLD</span> Plant
          Manufacturer in India
        </h1>

        <p className="text-body-large max-w-2xl lg:max-w-3xl mx-auto mb-8 lg:mb-10">
          Energy-efficient, boiler-free Zero Liquid Discharge systems engineered
          for full CPCB / SPCB compliance — cutting operating costs by up to 80%
          across pharmaceutical, chemical, textile and food industries.
        </p>

        {/* Dual CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-8">
          <ZLDCalculatorTrigger className="w-full sm:w-auto" />
          <Button
            variant="outline"
            size="xl"
            onClick={scrollToContact}
            className="w-full sm:w-auto border-2 font-semibold"
            aria-label="Request technical consultation"
          >
            <Phone className="w-5 h-5" aria-hidden="true" />
            Request Technical Consultation
          </Button>
        </div>

        {/* Trust badges */}
        <ul
          aria-label="Trust signals"
          className="inline-flex flex-wrap items-center justify-center gap-x-5 gap-y-3 max-w-3xl mx-auto glass-pill px-5 py-3"
        >
          {trustBadges.map(({ icon: Icon, label }) => (
            <li
              key={label}
              className="flex items-center gap-2 text-sm font-medium text-foreground/80"
            >
              <span className="w-7 h-7 rounded-full bg-secondary/15 text-secondary flex items-center justify-center">
                <Icon className="w-3.5 h-3.5" aria-hidden="true" />
              </span>
              {label}
            </li>
          ))}
        </ul>

      </div>

      <div className="relative w-full max-w-4xl lg:max-w-5xl 3xl:max-w-6xl 5xl:max-w-7xl mx-auto px-5 lg:px-6">
        <div className="lcp-image-container relative shadow-elevated">
          <picture>
            <source
              type="image/avif"
              srcSet="/hero-background-mobile.avif 768w, /hero-background-desktop.avif 1280w"
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 1280px"
            />
            <source
              type="image/webp"
              srcSet="/hero-background-mobile.webp 768w, /hero-background-desktop.webp 1280w"
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 1280px"
            />
            <img
              src="/hero-background-desktop.webp"
              alt="Rameon Energy Zero Liquid Discharge industrial plant"
              width={1280}
              height={697}
              loading="eager"
              decoding="async"
              fetchPriority="high"
              className="w-full h-full object-cover"
            />
          </picture>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
